export function copyTextLegacy(text) {
  if (typeof document === "undefined" || !document.body) return false;

  const textarea = document.createElement("textarea");
  textarea.value = String(text ?? "");
  textarea.setAttribute("readonly", "");
  textarea.style.position = "fixed";
  textarea.style.left = "-9999px";
  textarea.style.opacity = "0";

  try {
    document.body.appendChild(textarea);
    textarea.focus();
    textarea.select();
    return Boolean(document.execCommand?.("copy"));
  } catch {
    return false;
  } finally {
    textarea.remove();
  }
}

export async function copyTextToClipboard(text) {
  const value = String(text ?? "");

  if (typeof navigator !== "undefined" && navigator.clipboard?.writeText) {
    try {
      await navigator.clipboard.writeText(value);
      return true;
    } catch {
      // Windows browsers and embedded webviews can expose Clipboard API while
      // rejecting the actual write. Fall through to the selection-based copy.
    }
  }

  return copyTextLegacy(value);
}
